import { useMediaQuery } from "react-responsive";

// Define breakpoints
export const breakpoints = {
  mobile: 768, // up to 767px
  tablet: 1024, // 768px to 1023px
};

// Custom hooks for screen sizes
export const useIsMobile = () => {
  return useMediaQuery({ maxWidth: breakpoints.mobile - 1 }); // < 768px
};

export const useIsTablet = () => {
  return useMediaQuery({
    minWidth: breakpoints.mobile,
    maxWidth: breakpoints.tablet - 1, // 768px - 1023px
  });
};

export const useIsDesktop = () => {
  return useMediaQuery({ minWidth: breakpoints.tablet }); // ≥ 1024px
};

export { breakpoints as default };
